import React, { useCallback, useEffect, useState } from 'react'
import { Button, Input, message, Popconfirm, Space, Table } from 'antd';
import { useNavigate } from 'react-router';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint'; // Ekran boyutunu almak için

const AdminSupport = () => {
  const [dataSource, setdataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const screens = useBreakpoint(); // Ekran genişliğini almak için

  const columns = [
    {
      title: 'İsim',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (name) => <b>{name}</b>,
      responsive: ['xs', 'sm', 'md', 'lg'], // Küçük ekranlarda göster
    },
    {
      title: 'Soy İsim',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (lastName) => <b>{lastName}</b>,
      responsive: ['xs','md', 'lg'], // Orta ve büyük ekranlarda göster
    },
    {
      title: 'Talep',
      dataIndex: 'message',
      key: 'message',
      render: (text) => <p>{text.slice(0, 20)}...</p>,
      responsive: ['xs','sm', 'md', 'lg'],
    },
    {
      title: 'Blok',
      dataIndex: 'blockNum',
      key: 'blockNum',
      responsive: ['xs','sm','md', 'lg'],
    },
    {
      title: 'Telefon',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      responsive: ['xs','sm','md','lg'], // Sadece büyük ekranlarda göster
    },
    {
      title: 'Talep Tarihi',
      dataIndex: 'repairDate',
      key: 'repairDate',
      render: (text) => <p>{text.slice(0,10)}</p>,
      responsive: ['xs','sm','md', 'lg'],
    },
    {
      title: 'Başlangıç Saati',
      dataIndex: 'startTime',
      key: 'startTime',
      responsive: ['lg'],
    },
    {
      title: 'Bitiş Saati',
      dataIndex: 'endTime',
      key: 'endTime',
      responsive: ['lg'],
    },
    {
      title: 'Oluşturulma Tarihi',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => <p>{date.slice(0,10)}</p>,
      responsive: ['md', 'lg'],
    },
    {
      title: 'Durumu',
      dataIndex: 'durum',
      key: 'durum',
      render: () => <p style={{ color: "red" }}>Bekliyor...</p>,
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'Aksiyonlar',
      key: 'aksiyonlar',
      render: (_, record) => (
        <Space size={'middle'}>
          <Button onClick={() => navigate(`/admin/support/update/${record.id}`)} type='primary'>
            Düzenle
          </Button>
          <Popconfirm
            title='Kategori Sil'
            description='Kategoriyi silmek istediğinizden emin misin?'
            okText='Evet'
            cancelText='Hayır'
            onConfirm={() => deleteSupport(record.id)}
          >
            <Button type='primary' danger>Sil</Button>
          </Popconfirm>
          <Button onClick={() => markAsDone(record.id)} color='green' variant='filled'>
            Yapıldı
          </Button>
        </Space>
      ),
      responsive: ['xs', 'sm', 'md', 'lg'], // Her ekranda göster
    },
  ];

  const markAsDone = async (supportId) => {
    try {
      const response = await fetch(`${apiUrl}/api/support/${supportId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: true }),
      });
      if (response.ok) {
        fetchSupport();
        message.success('Destek talebi başarıyla tamamlandı');
      } else {
        message.error('Destek talebi tamamlanırken bir hata oluştu.');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSupport = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/support`);
      if (response.ok) {
        const data = await response.json();
        const pendingSupport = data.filter((req) => req.status === false);
        pendingSupport.sort((a, b) => {
          const dateA = new Date(a.repairDate);
          const dateB = new Date(b.repairDate);
          if (dateA - dateB !== 0) {
            return dateA - dateB;
          }
          return a.startTime.localeCompare(b.startTime);
        });
        setdataSource(pendingSupport);
        setFilteredData(pendingSupport);
      } else {
        message.error('Server Hatası Kullanıcılar Getirilemedi');
      }
    } catch (error) {
      console.log(error);
    }
  }, [apiUrl]);

  const deleteSupport = async (supportId) => {
    try {
      const response = await fetch(`${apiUrl}/api/support/${supportId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        fetchSupport();
        message.success('Destek talebi başarıyla silindi.');
      } else {
        message.error('Destek talebi silinirken bir hata oluştu.');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSupport();
  }, [fetchSupport]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = dataSource.filter(
      (item) =>
        item.firstName.toLowerCase().includes(value) ||
        item.lastName.toLowerCase().includes(value) ||
        item.message.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <Input
        placeholder='İsim, Soyisim veya Talep ara...'
        value={searchText}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: screens.xs ? '100%' : 300 }}
      />
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey='_id'
        scroll={{ x: 'max-content' }} // Mobilde yatay kaydırmayı aktif et
      />
    </>
  );
};

export default AdminSupport;
